// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import Echo from 'laravel-echo'
import Pusher from "pusher-js";
import VueClipboard from 'vue-clipboard2'
// import * as Sentry from '@sentry/browser'

window.pusher = Pusher;

// Set the production tip
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// if (Vue.config.productionTip) {
//   Sentry.init({
//     dsn: 'https://621c159a7ded4feba84434b5a732294b@sentry.io/1423037',
//     integrations: [new Sentry.Integrations.Vue()]
//   })
// }

// Create a global event bus
export const bus = new Vue()

router.beforeEach((to, from, next) => {
  // if (to.meta.scopes && to.meta.scopes.length > 0) {
  //   const scopes = localStorage.getItem('scopes').split(',').map(x => parseInt(x))
  //
  //   if (scopes.some(e => to.meta.scopes.includes(e))) {
  //     console.log('Grant 2')
  //     next()
  //     return
  //   }
  //
  //   console.log('Grant failed')
  //   next(false)
  //   return
  // }

  console.log('Grant 1')
  next()
})

// Include some global vendor functionality
Vue.use(VueClipboard);

Vue.prototype.$echo = new Echo({
  broadcaster: 'reverb',
  key: '5xrpshrov333svy5h1dy',
  wsHost: 'ct.learningmatters.nl',
  wsPort: 8080,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ['ws'],
});

// Create the Vue instance
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
